'use client';

import type { NextPage } from 'next';
import { Container } from '@mui/material';
import { DefaultPageProps } from '@/types/types/page/pages';
import { useInitialPageLoad } from '@/hooks/general/useInitialPageLoad';
import { MainContentWrapper } from '@/components/layout/MainContentWrapper/MainContentWrapper';
import { NMDashboard } from '@/components/blocks/dashboard/NMDashboard/NMDashboard';
import { INMSurveysData } from '@/types/types/forms/nmDashboard/nmDashboard.interface';

interface DashboardProps extends DefaultPageProps {
    surveysData?: INMSurveysData;
}

const NonMemberDashboardPage: NextPage<DashboardProps> = ({ phrases, dictionary, surveysData }) => {
    useInitialPageLoad({ phrases, countries: dictionary.countries });

    return (
        <MainContentWrapper phrases={phrases} dictionary={dictionary} className="page-nmdashboard">
            <Container sx={{ mt: 4, mb: 4 }}>
                <NMDashboard surveysData={surveysData} />
            </Container>
        </MainContentWrapper>
    );
};

export default NonMemberDashboardPage;
